import modalChangePassword from '@/components/OpenCall/changePassword/changePassword.vue'
import modalEditUser from '@/components/OpenCall/editUser/editUser.vue'
import editIcon from '@/components/Icons/Edit/Edit.vue'
import iconPencilSquare from '@/components/Icons/PencilSquare/PencilSquare.vue';


export default {
name: 'User',

components: {
    modalChangePassword,
    modalEditUser,
    editIcon,
    iconPencilSquare,

},

data() {
    return{
        loader: false,
        temp_obras: [],
        temp_portafolio: [],

    menu: false,
    menuUser: 0,
    picked: false,
    modal_changePassword: false,
    modal_editUser: false,

    /**     FILTERS     */
    tempSelect: "Selecciona...",
    typeSelectFlag: false,
    options: [
            {label: 'Alfabéticamente', value: 'alpha'},
            {label: 'Mayor a menor promedio', value: 'higher'},
            {label: 'Menor a mayor promedio', value: 'less'}
    ],

    search: "",

    actualKey: 0,
    score: 0,
    noScore: 5,
    managers: [],
    managers_list: false,
    opencall: {
        curriculum_vitae: "(...)",
        email: "(...)",
        finished: true,
        name: "(...)",
        obras: {},
        personal_data: {},
        portafolio: {},
        removed: false,
        status: "(...)",
        _id: "(...)",
        managers: []
    },

    items_finalist: [
        {
            'id':'1',
            'artist': 'a. de Carmen Reynoso Portillo',
            'calification': 'pendiente',
            '': {'2018-09-09': '{{asd}}<div></div>'},
        },
        {
            'id':'2',
            'artist': 'rturo Miguel Aldana Hurtado',
            'calification': '-',
            '': {'2018-09-09': '{{asd}}<div></div>'},
        },
        {
            'id':'3',
            'artist': 'ector Guadalupe Aldaz Hernandez',
            'calification': '4.4',
            '': {'2018-09-09': '{{asd}}<div></div>'},
        }
    ],
    columns: [
        { label: 'Artista', name: 'name'},
        { label: 'Tu Calificación', name: 'score'},
        { label: 'Acciones', name: 'action'},
    ]

    }
},

methods: {

    checkImgs(){
        //// obras
        this.temp_portafolio = [];
        this.temp_obras = [];

        var keysToDelete = [];
        for (let i = 0; i < this.opencall.obras.length; i++) {
            var index = this.opencall.obras[i];

            // var url = "https://sandbox.api.salonacme.com/image/"+index.file;
            var url = this.$session.get('_aws_url_file') + index.file;
            if(index.file != '' && index.file.split('.')[1] !== 'pdf'){
                var objImg = new Image();
                // objImg.src = 'https://sandbox.api.salonacme.com/image/'+index.file;
                objImg.src = this.$session.get('_aws_url_file') + index.file;
                // if(objImg.naturalHeight<1 && objImg.naturalWidth<1)
                // {
                //     keysToDelete.push(i);
                // }
                if(objImg.naturalHeight>0 && objImg.naturalWidth>0)
                {
                    this.temp_obras.push(index);
                }

            }

            if(index.file != '' && index.file.split('.')[1] === 'pdf'){

                this.pdfExist_obras(url,i);

            }

        }
        for(var i = 0; i < keysToDelete.length; i++) {
            this.opencall.obras.splice(keysToDelete[i], 1);
        }

        //// portafolio
        var keysToDelete = [];
        for (let i = 0; i < this.opencall.portafolio.length; i++) {
            var index = this.opencall.portafolio[i];

            // var url = "https://sandbox.api.salonacme.com/image/"+index.file;
            var url = this.$session.get('_aws_url_file') + index.file;
            if(index.file != '' && index.file.split('.')[1] !== 'pdf'){
                var objImg = new Image();
                // objImg.src = 'https://sandbox.api.salonacme.com/image/'+index.file;
                objImg.src = this.$session.get('_aws_url_file') + index.file;
                // if(objImg.naturalHeight<1 && objImg.naturalWidth<1)
                // {
                //     keysToDelete.push(i);
                // }
                if(objImg.naturalHeight>0 && objImg.naturalWidth>0)
                {
                    this.temp_portafolio.push(index);
                }

            }

            if(index.file != '' && index.file.split('.')[1] === 'pdf'){

                this.pdfExist_portafolio(url,i);

            }

        }
        for(var i = 0; i < keysToDelete.length; i++) {
            this.opencall.portafolio.splice(keysToDelete[i], 1);
        }

    },
    pdfExist_obras(url, index){
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onprogress = (event) => {
            if (event.lengthComputable) {
                // console.log('isgood');
                this.temp_obras.push(this.opencall.obras[index]);
            } else {
                // this.opencall.obras.splice(index, 1);
            }
            xhr.abort();
        };
        xhr.send();
    },
    pdfExist_portafolio(url, index){
        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        xhr.onprogress = (event) => {
            if (event.lengthComputable) {
                // console.log('isgood');
                this.temp_portafolio.push(this.opencall.portafolio[index]);
            } else {
                // this.opencall.portafolio.splice(index, 1);

            }
            xhr.abort();
        };
        xhr.send();
    },


    convertToMoney(amount, decimalCount = 2, decimal = ".", thousands = ","){
        try {
        decimalCount = Math.abs(decimalCount);
        decimalCount = isNaN(decimalCount) ? 2 : decimalCount;

        const negativeSign = amount < 0 ? "-" : "";

        let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
        let j = (i.length > 3) ? i.length % 3 : 0;

        return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
        } catch (e) {
        }
    },
    isCompleteUrl (value) {
        var url = value;
        console.log(url);
        return url.search("http") >= 0
        ? (url)
        : ('//'+url)
    },
    backOpenCall(){
        if(this.actualKey > 0){
            this.actualKey--;
            this.actions(this.items_finalist[this.actualKey]._id);
            // return to personal data
            this.menuUser = 0;
        }
    },
    nextOpenCall(){
        if( this.actualKey < this.items_finalist.length-1 ){
            this.actualKey++;
            this.actions(this.items_finalist[this.actualKey]._id);
            // return to personal data
            this.menuUser = 0;
        }
    },
    actions(id, key = null){ // Load opencall data
        this.$root.opencall_view = false;
        if(key != null) // i think is to next and before
            this.actualKey = key;
        (async () => {

            await fetch('https://sandbox.api.salonacme.com/manager/get_opencall', {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                _id: this.$session.get('_id'),
                _id_opencall: id,
                type: 'comun'
            })
            }).then(async response => {
            response = await response.json();
            if(response.status)
            {
                this.score = response.score;
                this.opencall = (response.opencall);
                this.managers = response.managers;
                this.checkImgs();
            }else{
                alert(response.msg);
            }

            })
            .catch(error => alert(error));

        })();

    },
    callOrder(order){
        this.get_opencalls_finalist(order);
    },
    searchF(){
        this.get_opencalls_finalist(null, this.search);
    },
    get_opencalls_finalist(order = null, search = null){

        (async () => {
            this.loader = true;

            await fetch('https://sandbox.api.salonacme.com/manager/get_opencalls_comun_finalist', {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                _id: this.$session.get('_id'),
                order: order,
                search: search
            })
            }).then(async response => {
            response = await response.json();
            if(response.status)
            {
                this.items_finalist = response.opencalls;
                for (let index = 0; index < this.items_finalist.length; index++) {
                    if(typeof this.items_finalist[index].score == 'undefined' || this.items_finalist[index].score < 1){
                        this.items_finalist[index].score = false;
                    }
                }
                // for (let index = 0; index < this.items_finalist.length; index++) {
                //     if(typeof this.items_finalist[index].comun_average == 'undefined'){
                //         this.items_finalist[index].comun_average = '-';
                //         this.items_finalist[index].forOrder = -1;
                //     }else
                //     if(!this.items_finalist[index].managers){
                //         this.items_finalist[index].comun_average = 'pendiente';
                //         this.items_finalist[index].forOrder = 0;
                //     }else
                //     if(typeof this.items_finalist[index].comun_average !== 'undefined'){
                //         var temp = this.items_finalist[index].comun_average.$numberDecimal;
                //         this.items_finalist[index].comun_average = parseFloat(temp).toFixed(2);
                //         this.items_finalist[index].forOrder = parseFloat(temp).toFixed(2);
                //     }
                // }
                if(order == 'higher' && search == null) {
                  this.items_finalist.sort(
                    ((a, b) => b.score - a.score)
                  );
                }

                if(order == 'less' && search == null) {
                  this.items_finalist.sort(
                    ((a, b) => a.score - b.score)
                  );
                }


            }else{
                alert(response.msg);
            }

            })
            .catch(error => alert(error));
            this.loader = false;
        })();

    },
    changeScore(score){

        ( async () => {

            await fetch('https://sandbox.api.salonacme.com/manager/set_score', {
            method: 'POST',
            headers:{
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                _id: this.$session.get('_id'),
                _id_opencall: this.opencall._id,
                score: score,
                type: 'comun'
            })
            }).then(async response => {
            response = await response.json();
            if(response.status)
            {
                this.actions(this.opencall._id);
            }else{
                alert(response.msg);
            }

            })
            .catch(error => alert(error));

        })();
    },
},

watch: {
    score: function (newQuestion) {
        this.noScore = 5-this.score;
    },
    '$root.opencall_view': function (newQuestion) {
        if(this.$root.opencall_view)
            this.get_opencalls_finalist();
    }
},

mounted(){
    this.get_opencalls_finalist();
}


}
